<template>
  <v-dialog
      v-if="distribuidor"
      v-model="show"
      max-width="500"
      scrollable
  >
    <v-card>
      <!-- Titulo del dialog -->
      <v-card-title class="titulo_card">{{ distribuidor.text }}</v-card-title>
      <!-- Contenido del dialog -->
      <v-card-text>
        <p>{{ $t("Para contratar este servicio contacta con {distribuidor}", {
          distribuidor: distribuidor.text
        }) }}:</p>
        <ul>
          <li>{{ $t("Teléfono") }}: <a :href="`tel:${distribuidor.telefono}`">{{ distribuidor.telefono }}</a></li>
          <li>{{ $t("Email") }}: <a :href="`mailto:${distribuidor.email}`">{{ distribuidor.email }}</a></li>
        </ul>
      </v-card-text>
      <!-- Fin del contenido -->

      <v-card-actions>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pb-1">
            <div class="text-sm-right text-center">
              <v-btn small @click="show = false" class="ml-2">{{ $t("Cerrar") }}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogContratarDistribuidor',
  data() {
    return {
      show: false,
      distribuidor: null,
    }
  },
  methods: {
    open_dialog(distribuidor){
      this.distribuidor = distribuidor
      this.show = true
    },
  }
}
</script>